import { render, staticRenderFns } from "./OnboardingConfirmationBusiness.vue?vue&type=template&id=b7dd3aa0&"
import script from "./OnboardingConfirmationBusiness.vue?vue&type=script&lang=js&"
export * from "./OnboardingConfirmationBusiness.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingConfirmationBusiness.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports